<div class="col-12 xl:col-12 lg:col-12" *ngIf="noImports">
  <h3>There are no Transferred orders</h3>
</div>

<div
  style="
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: gray;
    opacity: 0.3;
    display: flex;
  "
  *ngIf="!noImports && !orderImports"
>
  <img
    src="assets/images/loader.gif"
    style="margin: auto; text-align: center"
    width="50"
    height="50"
    alt="load"
  />
</div>

<div *ngIf="orderImports && orderImports.length > 0">
  <h2>Order Transferred ({{ orderImports.length }})</h2>
  <p-table
    [value]="orderImports"
    selectionMode="single"
    [(selection)]="selectedImport"
    [rows]="10"
    [paginator]="true"
    [totalRecords]="orderImports.length"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>File name</th>
        <th>Created On</th>
        <th>Status</th>
        <th>Uploaded by</th>
        <th>Entries Count</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-import>
      <tr (dblclick)="getOrderDetails(import)" [pSelectableRow]="import">
        <td>{{ import.fileName }}</td>
        <td>
          <b>{{ import.createdOn | datex : 'ddd DD MMM HH:mm' }}</b>
        </td>
        <td><i class="pi pi-info"></i> {{ import.status.name }}</td>
        <td>
          <i class="pi pi-user"></i>
          <small>{{ import.uploadedByUserFirstName }} {{ import.uploadedByUserLastName }}</small>
        </td>
        <td><i class="pi pi-list"></i> {{ import.entriesCount }} <span>order(s)</span></td>
      </tr>
    </ng-template></p-table
  >
</div>

<p-panel
  header="Entries for file upload: {{ selectedOrderImport.fileName }}"
  [showHeader]="true"
  *ngIf="
    selectedOrderImport &&
    selectedOrderImport.orderImportDetails &&
    selectedOrderImport.orderImportDetails.length > 0
  "
>
  <div class="col-12 xl:col-12 lg:col-12">
    <div style="overflow: scroll">
      <p-table
        #completedOrderDt
        class="dynamic-size-table"
        [value]="selectedOrderImport.orderImportDetails"
        [columns]="cols"
        [loading]="isLoadingOrderDetails"
        [exportFilename]="selectedOrderFilename"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="table-column" *ngFor="let col of cols; let i = index">{{ col.header }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <th class="table-column" *ngFor="let col of cols; let i = index">
              {{ item[col.field] }}
            </th>
          </tr>
        </ng-template>
      </p-table>

      <div *ngIf="completedOrderDt" class="ui-grid-row" style="margin-top: 10px; text-align: right">
        <button
          type="button"
          pButton
          icon="fa fa-download"
          (click)="downloadToCSV()"
          label="Download CSV"
          class="ui-button green-btn"
        ></button>
      </div>
    </div>
  </div>
</p-panel>

<p-dialog
  header="Processing your request"
  [(visible)]="isLoadingOrderDetails"
  [modal]="true"
  [responsive]="true"
  (onHide)="hideDialog()"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>
